import React from 'react'
import { Routes, Route } from "react-router-dom";

import MarcajesRRHH from '../componentes/view/rrhh/macajes/marcaje';
import ListaHorasExtras from '../componentes/view/rrhh/macajes/listamarcaje';
import ListaHorasSinCierre from '../componentes/view/rrhh/macajes/marcasincierra';
import PagoChequeList from '../componentes/view/rrhh/pagos/pagocheque';
import EstructuraAPI from '../componentes/view/rrhh/macajes/jerarquiamarcas';
import EstructuraAPI2 from '../componentes/view/rrhh/macajes/solicitudCambiosHoras';
import UserRoleControlSystem from '../componentes/view/rrhh/usuarios/permisos_rol';

import UsuariosList from '../componentes/view/rrhh/usuarios/usuarios';
import DescuentoEmpledos from '../componentes/view/rrhh/empleados/empleados_con_descuento' 
import ReceptorDatosPage from '../componentes/view/rrhh/macajes/ReceptorDatosPage';
export const RrhhRoutes = () => {

  return (
    <Routes>            

      <Route path='/marcas' element={ <MarcajesRRHH/>}/>
      <Route path='/autorizacionmarcas' element={ <ListaHorasExtras/>}/>
      <Route path='/cierremarcas' element={ <ListaHorasSinCierre/>}/>
      <Route path='/chequesplanilla' element={ <PagoChequeList/>}/>
      <Route path='/validacionxjerarquia' element = {<EstructuraAPI/>} /> 
      <Route path='/cambiohoras' element = {<EstructuraAPI2/>} /> 
      <Route path='/usuarios' element = {<UsuariosList/>} />
      <Route path='/control_descuento_empleados' element={<DescuentoEmpledos/>} />
      <Route path='/permisos' element = {<UserRoleControlSystem/>} />  
      <Route path='/incidencia' element = {<ReceptorDatosPage/>} /> 


    </Routes>
  ) 
}